module.exports = "<div class=\"slidedown\" *ngIf=\"_state\">\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/slidedown/slidedown.html
// module id = ./src/app/shared/components/slidedown/slidedown.html
// module chunks = main